import axiosDebug from 'src/utils/axiosDebug';

export const postRequest = (url, data, resolve, reject) => {
  return axiosDebug
    .post(url, data)
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      reject(error);
    });
};
